<template>
  <b-modal
    ref="creationModal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    hide-footer
    size="lg"
  >
    <div class="d-block">
      <div class="titre-btn">{{ title }}</div>
      <slot></slot>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  methods: {
    openModal () {
      this.$refs.creationModal.show()
    },
    closeModal () {
      this.$refs.creationModal.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/creationModal.vue